import React, { ReactElement, ForwardedRef } from 'react';
import RichTextEditor from '../rich-text-editor/rich-text-editor.component';
import FormatService from '../../services/format-service';
import useStylesFieldTextRich from './field-text-rich.styles';

const FieldTextRich: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => {
  const {
    isPlain,
    isSimple,
    isInline,
    isFullWidth,
    withMentions,
    withHashtags,
    withAutoFocus,
    withSendByEnter,
    value,
    className,
    mentionRouteRoot,
    hashtagRouteRoot,
    mentionList,
    hashtagList,
    onKeyDown,
    onFieldChange,
    input,
    meta,
  } = props;

  const {
    touched: isTouched,
    invalid: isInvalid,
    error: formError,
    submitError: formSubmitError,
    modifiedSinceLastSubmit,
  } = (meta || {}) as FormFieldMetaProps;

  const { classes } = useStylesFieldTextRich();

  const withErrors: boolean = ((isTouched && isInvalid) || !!formError || !!formSubmitError)
    && !modifiedSinceLastSubmit;

  const containerBorderedClassName: string | undefined = !isSimple
    ? classes.containerFieldTextRichBordered : undefined;
  const containerInlineClassName: string | undefined = isInline ? classes.containerFieldTextRichInline : undefined;
  const containerFullWidthClassName: string | undefined = isFullWidth ? classes.containerFullWidth : undefined;

  return (
    <div
      ref={ref}
      className={FormatService.formatClassNames(
        containerBorderedClassName, containerInlineClassName, containerFullWidthClassName,
      )}
    >
      <RichTextEditor
        isSimple={isSimple}
        withMentions={withMentions}
        withHashtags={withHashtags}
        withAutoFocus={withAutoFocus}
        withSendByEnter={withSendByEnter}
        value={(isPlain ? value : (input && input.value)) || ''}
        className={FormatService.formatClassNames(classes.fieldTextRich, className)}
        mentionRouteRoot={mentionRouteRoot}
        hashtagRouteRoot={hashtagRouteRoot}
        mentionList={mentionList}
        hashtagList={hashtagList}
        onFieldChange={onFieldChange}
        onKeyDown={onKeyDown}
      />
      {
        !isPlain && withErrors && (
          <div className={classes.error}>
            {formError || formSubmitError}
          </div>
        )
      }
    </div>
  );
}));

export default FieldTextRich;
